import { SxProps, Theme } from '@mui/material';
import { createAvailChipItems } from '@/components/Focus/utils/newScheduleAvails';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { useAppSelector } from '@/redux/hooks';
import { selectAudioLanguagesMap, selectSubtitlesLanguagesMap } from '@/redux/selectors/constantsSelectors';
import { FocusVersionScheduling, ScheduleAvailType } from '@/redux/slices/slice_types';
import ScheduleAvailChipButton from './ScheduleAvailChipButton';
import { getScheduleAvailValues } from '../utils/availSchedule';

type VersionSchedulingAvailChipProps = {
  type: ScheduleAvailType;
  schedule: FocusVersionScheduling;
  sx?: SxProps<Theme>;
};

const typeToIconNameMap = {
  audio: 'music',
  timedtext: 'subtitles',
  territories: 'map'
};

const VersionSchedulingAvailChip = ({ type, schedule, sx }: VersionSchedulingAvailChipProps) => {
  const audioLanguagesMap = useAppSelector(selectAudioLanguagesMap);
  const subtitleLanguagesMap = useAppSelector(selectSubtitlesLanguagesMap);

  const values = getScheduleAvailValues(schedule, type);

  const items = createAvailChipItems({
    values,
    type,
    allLanguagesMap: type === 'audio' ? audioLanguagesMap : subtitleLanguagesMap
  });

  return <ScheduleAvailChipButton icon={<PolarisIcon icon={typeToIconNameMap[type]} height={16} />} caption={items?.length} items={items} sx={sx} />;
};

export default VersionSchedulingAvailChip;
